import React from 'react';
import imgGirl from '../../../assets/images/error-img-girl.png';
import { siteUrl } from "../../../utils/siteUrl";
import './content-404.scss';

const Content404 = props => {
    var homeLink = siteUrl + '/'

    return (
        <div className="f-content-404">
            <span className="f-fake" />
            <div className="f-text-container">
                <label className="f-alert">¡UPS!</label>
                <label className="f-title">No encontramos lo que estás buscando</label>
                <label className="f-description">Parece que algo está mal. Estamos trabajando para resolverlo.</label>
                <a href={homeLink} className="f-redirect">
                    <button className="f-button">Inicio</button>
                </a>
            </div>
            <img
                className="f-error-img"
                src={imgGirl}
                alt="Imagen mujer 404"
            />
        </div>
    )
}

export default Content404
